import * as types from "../actions/ActionTypes";

const defaultState = {
  seriePostPending: false,
  seriePost: {},
  seriePostError: {},

  serieMediaPostPending: false,
  serieMediaPost: {},
  serieMediaPostError: {},

  serieEpisodePostPending: false,
  serieEpisodePost: {},
  serieEpisodePostError: {},

  serieSeasonPostPending: false,
  serieSeasonPost: {},
  serieSeasonPostError: {},

  seriePausePending: false,
  seriePause: {},
  seriePauseError: {},
};

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case types.SERIE_POST_PENDING:
      return Object.assign({}, state, {
        seriePostPending: true,
      });
    case types.SERIE_POST_FULFILLED:
      return Object.assign({}, state, {
        seriePostPending: false,
        seriePost: action.payload,
      });
    case types.SERIE_POST_REJECTED:
      return Object.assign({}, state, {
        seriePostPending: false,
        seriePostError: action.payload.response,
      });

    case types.SERIE_MEDIA_POST_PENDING:
      return Object.assign({}, state, {
        serieMediaPostPending: true,
      });
    case types.SERIE_MEDIA_POST_FULFILLED:
      return Object.assign({}, state, {
        serieMediaPostPending: false,
        serieMediaPost: action.payload,
      });
    case types.SERIE_MEDIA_POST_REJECTED:
      return Object.assign({}, state, {
        serieMediaPostPending: false,
        serieMediaPostError: action.payload.response,
      });

    case types.SERIE_EPISODE_POST_PENDING:
      return Object.assign({}, state, {
        serieEpisodePostPending: true,
      });
    case types.SERIE_EPISODE_POST_FULFILLED:
      return Object.assign({}, state, {
        seriecEpisodePostPending: false,
        seriecEpisodePost: action.payload,
      });
    case types.SERIE_EPISODE_POST_REJECTED:
      return Object.assign({}, state, {
        serieEpisodePostPending: false,
        serieEpisodePostError: action.payload.response,
      });

    case types.SERIE_SEASON_POST_PENDING:
      return Object.assign({}, state, {
        serieSeasonPostPending: true,
      });
    case types.SERIE_SEASON_POST_FULFILLED:
      return Object.assign({}, state, {
        seriecSeasonPostPending: false,
        seriecSeasonPost: action.payload,
      });
    case types.SERIE_SEASON_POST_REJECTED:
      return Object.assign({}, state, {
        serieSeasonPostPending: false,
        serieSeasonPostError: action.payload.response,
      });

    case types.SERIE_PAUSE_PENDING:
      return Object.assign({}, state, {
        seriePausePending: true,
      });

    case types.SERIE_PAUSE_FULFILLED:
      return Object.assign({}, state, {
        seriePausePending: false,
        seriePause: action.payload,
      });
    case types.SERIE_PAUSE_REJECTED:
      return Object.assign({}, state, {
        seriePausePending: false,
        seriePauseError: action.payload.response,
      });

    case "LOGOUT":
      return defaultState;
    default:
      return state;
  }
}
